export const MY_WORK_ITEM_AR_TASK   = 'actionRequiredTask'
export const MY_WORK_ITEM_AS_TASK   = 'assignedToTask'
export const MY_WORK_ITEM_EVENT     = 'event'
export const MY_WORK_ITEM_MENTION   = 'mention'
export const MY_WORK_ITEM_MEETING   = 'meeting'
export const MY_WORK_ITEM_REMINDER  = 'reminder'
export const MY_WORK_ITEM_REPORT    = 'report'
export const MY_WORK_ITEM_DEADLINE  = 'deadline'

export const MY_WORK_ALL_EVENTS     = 'allEvents'       // MY_WORK_ITEM_EVENT + MY_WORK_ITEM_DEADLINE
export const MY_WORK_ALL_REMINDERS  = 'allReminders'    // MY_WORK_ITEM_REMINDER + MY_WORK_ITEM_MENTION + MY_WORK_ITEM_REPORT

export const MY_WORK_ITEM_TYPES: any = {
    [MY_WORK_ITEM_AR_TASK]: {
        label: 'Action required',
        icon: 'i5-user'
    },
    [MY_WORK_ITEM_AS_TASK]: {
        label: 'Assigned',
        icon: 'i5-user-assigned'
    },
    [MY_WORK_ITEM_EVENT]: {
        label: 'Events',
        icon: 'i5-events-summary'
    },
    [MY_WORK_ITEM_MENTION]: {
        label: 'Mentions',
        icon: ' i5-mention'
    },
    [MY_WORK_ITEM_MEETING]: {
        label: 'Meetings',
        icon: 'i5-meeting'
    },
    [MY_WORK_ITEM_REMINDER]: {
        label: 'Reminders',
        icon: 'i5-notification'
    },
    [MY_WORK_ITEM_REPORT]: {
        label: 'Reports',
        icon: 'i5-reports'
    },
    [MY_WORK_ITEM_DEADLINE]: {
        label: 'Task deadlines',
        icon: 'i5-deadline'
    },

    // not actual types just combined of previous
    [MY_WORK_ALL_EVENTS]: {     // MY_WORK_ITEM_EVEN
        label: 'Events',
        // icon: 'i5-events-summary'
    },
    [MY_WORK_ALL_REMINDERS]: {  // MY_WORK_ITEM_REMINDER + MY_WORK_ITEM_MENTION + MY_WORK_ITEM_REPORT
        label: 'Reminders',
        // icon: 'i5-notification'
    },
}
